import { defineStore } from 'pinia';
import { markRaw } from 'vue';

export const useTaskStore = defineStore('task', {
  state: () => ({
    tasks: [],
    taskSetProfiles: [],
    taskSetProfilesObj: {},
    itemTemplates: [],
  }),
  getters: {
    getTasks: (state) => state.tasks,
    getTaskSetProfiles: (state) => state.taskSetProfiles,
    getTaskSetProfilesObj: (state) => state.taskSetProfilesObj,
  },
  actions: {
    setTasks(tasks) {
      // A schedule's task tree is tens of thousands of objects on large P6
      // schedules and every consumer reads it as a whole (re-assignment is the
      // only change signal anyone relies on), so keep it out of the reactive
      // proxy — the main web app freezes the same response for the same reason.
      this.tasks = markRaw(tasks);
    },
    resetPageState() {
      this.tasks = [];
    },
    setTaskSetProfiles(taskSetProfiles) {
      this.taskSetProfiles = taskSetProfiles;
    },
    setTaskSetProfilesObj(taskSetProfilesObj) {
      this.taskSetProfilesObj = taskSetProfilesObj;
    },
    setItemTemplates(itemTemplates) {
      this.itemTemplates = itemTemplates;
    },
  },
});
